<svg
  width="21"
  height="8"
  viewBox="0 0 21 8"
  fill="#282828"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M20.5 7.50101L20.1569 7.50101C19.096 7.50101 18.0786 7.07958 17.3284 6.32943L12.6213 1.62232C11.4497 0.450751 9.55025 0.450754 8.37868 1.62233L3.67157 6.32943C2.92143 7.07958 1.90401 7.50101 0.843146 7.50101L0.5 7.50101"
    stroke="#2E2E2E"
    stroke-linecap="round"
  />
</svg>
